var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 35,
    viewBox: "0 0 70 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02091 32.7107V2.28925L16.3674 4.08256C28.741 5.62926 41.259 5.62926 53.6326 4.08256L67.9791 2.28925V32.7107L53.6326 30.9174C41.259 29.3707 28.741 29.3707 16.3674 30.9174L2.02091 32.7107Z",
    fill: "#C09E3F",
    stroke: "white",
    strokeWidth: 4.04183
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenNew);
export default __webpack_public_path__ + "static/media/screen_new.f96a1894.svg";
export { ForwardRef as ReactComponent };